import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AppModule } from '../app.module';
import { AppContext } from '../app.context';
import { LoaderService } from '../_infrastructure/loader-service';
import { DictionaryPipe, BoolToImgPipe } from '../_infrastructure/pipes';
import { AppMasterComponent } from '../app-master/app-master.component';
import { ClientDetailsComponent } from '../clients/client-details/client-details.component';
import { ClientsListComponent } from '../clients/clients-list/clients-list.component';
import { InstancesListComponent } from '../instances/instances-list/instances-list.component';
import { LoginComponent } from '../login/login.component';
import { MatTab } from '@angular/material/tabs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
declare var $: any;


@Component({
  selector: 'app-root',
  templateUrl: './app-root.component.html',
  imports: [
        AppRootComponent,
        LoginComponent,
        ClientsListComponent,
        AppMasterComponent,
        ClientDetailsComponent,
        DictionaryPipe,
        BoolToImgPipe,
        InstancesListComponent,
        //RouterOutlet,
        AppMasterComponent,
        MatTab,
        MatProgressSpinner
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrls: ['./app-root.component.css']
})
export class AppRootComponent {
  constructor(private router: Router, public appContext: AppContext, loaderService: LoaderService, private cdr: ChangeDetectorRef) {
    this.loggedIn = this.appContext.loggedIn;
    loaderService.spinnerStatusChanged.subscribe(loading => {
      if (loading) {
        $('#spinner').fadeIn();
        $('#spinner-overlay').fadeIn();
      } else {
        $('#spinner').fadeOut();
        $('#spinner-overlay').fadeOut();
      }
    });
  }

  public loggedIn: boolean = false;
  public showLoader: boolean = false;

  ngOnInit(): void {
  }
}
